import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/team/directory')({
  component: () => <PageStub title="Team Directory" description="All team members" />,
});
